<template>
  <div class="dictionary-setting-wrap">
    <vxe-grid
      ref="grid"
      show-overflow="title"
      :data="tableData"
      :columns="tableColumn" />
  </div>
</template>

<script>
import * as R from 'ramda'
import { mapGetters } from 'vuex'
import i18n from '@/locales'
import { ENABLE_USER_CUSTOM_DICTIONARY } from '@/constants'

const DEFAULT_DICTIONARY = i18n.t('originDictionary')

export default {
  name: 'DictionarySettingList',
  data () {
    const dictionaryObj = this.$t('dictionary')
    let dictionaryArr = []
    for (let i = 0, len = ENABLE_USER_CUSTOM_DICTIONARY.length; i < len; i++) {
      const key = ENABLE_USER_CUSTOM_DICTIONARY[i]
      dictionaryArr.push({
        label: dictionaryObj[key],
        key,
        defaultValue: DEFAULT_DICTIONARY[key],
      })
    }
    dictionaryArr = R.sort(R.ascend(R.prop('key')), dictionaryArr)
    return {
      loading: false,
      tableData: dictionaryArr,
      tableColumn: [
        {
          field: 'key',
          title: 'key',
          minWidth: 160,
          showOverflow: 'title',
          slots: {
            default: ({ row }) => {
              return [
                <list-body-cell-wrap row={row} field="key" copy />,
              ]
            },
          },
        },
        {
          field: 'defaultValue',
          title: this.$t('system.text_160'),
          minWidth: 160,
          showOverflow: 'title',
          slots: {
            default: ({ row }) => {
              return [
                <list-body-cell-wrap row={row} field="defaultValue" copy />,
              ]
            },
          },
        },
        {
          field: 'label',
          title: this.$t('system.text_161'),
          minWidth: 160,
          showOverflow: 'title',
          slots: {
            default: ({ row }) => {
              return [
                <list-body-cell-wrap
                  row={row}
                  field='label'
                  label={this.$t('system.text_161')}
                  copy
                  edit
                  showSuccessMessage={false}
                  ok={ val => this.handleConfirm(val, row.key) }
                  formRules={ [{ required: true, message: this.$t('system.text_162') }] } />,
              ]
            },
          },
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['scope']),
  },
  methods: {
    async handleConfirm (newLabel, key) {
      const errMap = await this.$refs.grid.fullValidate().catch(errMap => errMap)
      if (errMap) return
      // zh-CN
      // en
      // ja-JP
      const data = {
        zh: {},
        en: {},
        ja: {},
      }
      for (let i = 0, len = this.tableData.length; i < len; i++) {
        const item = this.tableData[i]
        if (key === item.key) {
          if (i18n.locale === 'zh-CN') {
            data.zh[key] = newLabel
            data.en[key] = i18n.t(`dictionary.${key}`, 'en')
            data.ja[key] = i18n.t(`dictionary.${key}`, 'ja-JP')
          }
          if (i18n.locale === 'en') {
            data.zh[key] = i18n.t(`dictionary.${key}`, 'zh-CN')
            data.ja[key] = i18n.t(`dictionary.${key}`, 'ja-JP')
            data.en[key] = newLabel
          }
          if (i18n.locale === 'ja-JP') {
            data.ja[key] = newLabel
            data.en[key] = i18n.t(`dictionary.${key}`, 'en')
            data.zh[key] = i18n.t(`dictionary.${key}`, 'zh-CN')
          }
        } else {
          if (i18n.locale === 'zh-CN') {
            data.zh[item.key] = item.label
            data.en[item.key] = i18n.t(`dictionary.${item.key}`, 'en')
            data.ja[item.key] = i18n.t(`dictionary.${item.key}`, 'ja-JP')
          }
          if (i18n.locale === 'en') {
            data.zh[item.key] = i18n.t(`dictionary.${item.key}`, 'zh-CN')
            data.ja[item.key] = i18n.t(`dictionary.${item.key}`, 'ja-JP')
            data.en[item.key] = item.label
          }
          if (i18n.locale === 'ja-JP') {
            data.zh[item.key] = i18n.t(`dictionary.${item.key}`, 'zh-CN')
            data.en[item.key] = i18n.t(`dictionary.${item.key}`, 'en')
            data.ja[item.key] = item.label
          }
        }
      }
      this.loading = true
      try {
        await this.$store.dispatch('globalSetting/putFetchGlobalSettingValue', {
          dictionary: data,
        })
        for (let i = 0, len = this.tableData.length; i < len; i++) {
          const item = this.tableData[i]
          if (key === item.key) {
            item.label = newLabel
          }
        }
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.dictionary-setting-wrap {
  ::v-deep {
    .vxe-table .vxe-default-input {
      border-radius: 0;
      padding-left: 11px;
      padding-right: 11px;
    }
  }
}
</style>
